import React, { useContext } from 'react';
import { RestaurantMultipleSelect } from './components/RestaurantMultipleSelect/RestaurantMultipleSelect';
import SelectedItem from 'components/SelectedItem/SelectedItem';
import {
	ChangeSubCategoryPositionContext,
	IChangeSubCategoryPositionContext,
	TChangeSubCategoryPositionSelectedRestaurant,
} from '../../../../../../changeSubCategoryPositionState/changeSubCategoryPositionContext';
import style from './RestaurantField.module.scss';

const RestaurantField: React.FC = () => {
	const { setAdditionalRestaurants, selectedAdditionalRestaurants } = useContext<IChangeSubCategoryPositionContext>(
		ChangeSubCategoryPositionContext,
	);

	const handleRemove = (id: string) => {
		const selectedItems: TChangeSubCategoryPositionSelectedRestaurant[] = selectedAdditionalRestaurants.filter(
			(el) => el.id !== id,
		);
		setAdditionalRestaurants(selectedItems);
	};

	return (
		<div className={style.container} data-test="RestaurantField">
			<div className={style.field}>
				<RestaurantMultipleSelect />
			</div>
			<div className={style.groupsList}>
				{selectedAdditionalRestaurants.map((el) => (
					<SelectedItem key={el.id} label={el.name} onDelete={() => handleRemove(el.id)} />
				))}
			</div>
		</div>
	);
};

export default RestaurantField;
